// alterado - revisado

const tipoUtilizacaoMotoList = [
    {
        id: 'L',
        descricao: 'Lazer',
        ordem: 10,
    },
    {
        id: 'T',
        descricao: 'Trabalho',
        ordem: 20,
    },
    {
        id: 'A',
        descricao: 'Lazer/Trabalho',
        ordem: 30,
    },
]

export default tipoUtilizacaoMotoList